/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditordiscard2Inputs */

const en_menueditordiscard2 = /** @type {(inputs: Menueditordiscard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard`)
};

const de_menueditordiscard2 = /** @type {(inputs: Menueditordiscard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwerfen`)
};

/**
* | output |
* | --- |
* | "Discard" |
*
* @param {Menueditordiscard2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditordiscard2 = /** @type {((inputs?: Menueditordiscard2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditordiscard2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditordiscard2(inputs)
	return de_menueditordiscard2(inputs)
});
export { menueditordiscard2 as "menuEditorDiscard" }